import { render, staticRenderFns } from "./coreBusiness.vue?vue&type=template&id=46127bcc&scoped=true"
import script from "./coreBusiness.vue?vue&type=script&lang=js"
export * from "./coreBusiness.vue?vue&type=script&lang=js"
import style0 from "./coreBusiness.vue?vue&type=style&index=0&id=46127bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46127bcc",
  null
  
)

export default component.exports